import { render } from "./PayersSection.vue?vue&type=template&id=1b6733ae"
import script from "./PayersSection.vue?vue&type=script&lang=js"
export * from "./PayersSection.vue?vue&type=script&lang=js"

import "./PayersSection.vue?vue&type=style&index=0&id=1b6733ae&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__